import { z } from 'zod';

export const dynamicConfigSchema = {
  whatsapp: z.object({
    enabled: z.boolean(),
  }),
};

type DynamicConfigMapping<Schema extends Record<string, unknown>> = {
  [key in keyof Schema]: Schema[key] extends Record<string, unknown>
    ? DynamicConfigMapping<Schema[key]>
    : z.infer<Schema[key]>;
};

export type DynamicConfigValues = DynamicConfigMapping<typeof dynamicConfigSchema>;

/** Default values for dynamic configs */
export const dynamicConfigDefaultValues: DynamicConfigValues = {
  whatsapp: {
    enabled: false,
  },
};
